import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { HubFrequentDriverModel } from '../../store/state/administration';
import { IconNames } from '../../common/constants/icon-names';
import { DirectivesModule } from '../../common/directives/directives.module';
import { FieldErrorMessages } from '../field-error-messages/field-error-messages.component';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-driver-autocomplete',
  imports: [
    CommonModule,
    TranslateModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSelectModule,
    FieldErrorMessages,
    DirectivesModule,
    SvgIconComponent,
  ],
  templateUrl: './driver-autocomplete.component.html',
  styleUrls: ['./driver-autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriverAutocompleteComponent<T extends HubFrequentDriverModel> {
  @Input() values: T[];
  @Input() fieldLabel: string;
  @Input() fieldControl: FormControl<T>;
  @Input() testId: string;
  @Input() controlName: string;
  @Input() isReadonly?: boolean;
  @Input() needAutocomplete?: string;
  @Input() isSelect?: boolean = false;
  @Input() required = false;

  @Output() driverSelected: EventEmitter<T> = new EventEmitter<T>(null);
  @Output() clearButtonClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>(null);

  iconNames = IconNames;

  onDriverSelected(value: T): void {
    this.driverSelected.emit(value);
  }

  onClearButtonClick(event: MouseEvent): void {
    this.clearButtonClick.emit(event);
  }

  getLabelSuffix(): string {
    return this.required ? ' *' : '';
  }
}
